<template>
<div class="chapter">
<div class="inner_page">
<h1 class="western" id="calibre_pb_2">
<p class="western2"> <br class="calibre2"/></p>
<p class="c4">A PERMUTED PRESS BOOK</p>
<p class="c4">Published at Smashwords</p>
<p class="c4"> <br class="calibre2"/></p>
<p class="c4">ISBN: 978-1-68261-116-6</p>
<p class="c4">ISBN (eBook): 978-1-68261-117-3</p>
<p class="c4"> <br class="calibre2"/></p>
<p class="c4">FAULT LINE</p>
<p class="c4">The Journal Book 5</p>
<p class="c4">© 2016 by Deborah D. Moore</p>
<p class="c4">All Rights Reserved</p>
<p class="c4"> <br class="calibre2"/></p>
<p class="c4">Cover art by Christian Bentulan</p>
<p class="c4"> <br class="calibre2"/></p>
<p class="c4">This book is a work of fiction. People,
places, events, and situations are the product of the author's
imagination. Any resemblance to actual persons, living or dead, or
historical events, is purely coincidental.</p>
<p class="c4"> <br class="calibre2"/></p>
<p class="c4">No part of this book may be reproduced,
stored in a retrieval system, or transmitted by any means without
the written permission of the author and publisher.</p>
<p class="c4"> <br class="calibre2"/></p>
<p class="c4"><img alt="tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk_html_m200a9aff.jpg" class="calibre3" id="graphics1" src="tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk_html_m200a9aff.jpg"/></p>
<p class="c4"> <br class="calibre2"/></p>
<p class="c4">Permuted Press</p>
<p class="c4">109 International Drive, Suite 300</p>
<p class="c4">Franklin, TN 37067</p>
<p class="c5"><span class="c6"><a href="http://permutedpress.com/" target="_blank"><span class="c7">http://permutedpress.com</span></a></span></p>
<p class="c4">Also in The Journal series:</p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2"> <br class="calibre2"/></p>
<p class="western2"> <br class="calibre2"/></p>
</h1>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tmp_81917b76c0dc0690a3d5075948c70f3d_BuZtIk.ch.fixed.fc.tidied.stylehacked.xfixed_split_002.vue?78298970